export default "__VITE_ASSET__Cmx_Evgb__"